import { render, staticRenderFns } from "./UpdateTaxDialog.vue?vue&type=template&id=8190c844&scoped=true"
import script from "./UpdateTaxDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTaxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8190c844",
  null
  
)

export default component.exports